﻿import React from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import {GuideFormBase, connectForm} from './GuideFormBase';
import RadioButton from '../../../Forms/Components/RadioButton';
import Select from '../../../Forms/Components/Select';
import Feedback, { FeedbackSection } from '../Components/Feedback';

import {
    required
} from '../../../Forms/Validation/rules';

class Step2Form extends GuideFormBase {

    constructor(props) {
        super(props);
    }

    shouldShowFeedbackPage = () => {
        return this.props.formData.occupation == 'student';
    }

    feedbackPage = () => {
        return (
            <React.Fragment>
                <h3>Även studier ger pension!</h3>
                <img src="https://www.lararforsakringar.se/globalassets/startsida/bocker.svg" />
                <FeedbackSection>
                    <p>
                        Studerar du på högskolenivå och får studiemedel från Centrala studiestödsnämnden (CSN),
                        betalar staten in pensionsavgifter för dig vilket innebär att du även under studietiden tjänar in
                        till pensionen. Men framför allt så kan studier leda till högre lön och därmed också högre
                        framtida pension.
                    </p>
                    <h4>Hur mycket pension blir det?</h4>
                    <p>
                        Studiemedlet består av två delar, studielån och studiebidrag. Det pensionsgrundande beloppet
                        är 138 procent av studiebidraget. Pensionsrätten är 18,5 procent av detta belopp.
                    </p>
                    <p>
                        Möjligheten att få pensionsavgift inbetald av staten gäller endast studier från och med år 1995
                        och framåt.
                    </p>
                    <h4>Minst fem år av arbete krävs</h4>
                    <p>
                        För att pensionsrätterna för dina studier ska kunna räknas med i din framtida pension ska du ha
                        minst fem år med inkomster från arbete innan du fyller 70 år. Inkomsterna ska motsvara minst
                        två inkomstbasbelopp.
                    </p>
                    <p>
                        Även om du har låga inkomster under studietiden så är det viktigt att börja tänka på pensionen.
                        Det är bättre att spara lite än inget alls.
                    </p>
                    <h4>När du närmar dig examen</h4>
                    <p>
                        Om du närmar dig slutet på dina studier och snart ska börja eller redan söker jobb, se till att
                        hamna på en arbetsplats med kollektivavtal så att du får en riktig tjänstepension. Saknas
                        kollektivavtal så är det inte säkert att du får någon tjänstepension.
                    </p>

                    {this.props.formData.age >= 30 &&
                        <React.Fragment>
                            <p>
                                Även om du har låga inkomster under studietiden så är det viktigt att börja tänka på pensionen.
                                Det är bättre att spara lite än inget alls.
                            </p>
                            <p>
                                Om du närmar dig slutet på dina studier och snart ska börja eller redan söker jobb, se till att
                                hamna på en arbetsplats med kollektivavtal så att du får en riktig tjänstepension.
                                Saknas kollektivavtal så är det inte säkert att du får någon tjänstepension.
                            </p>
                        </React.Fragment>
                    }

                </FeedbackSection>
            </React.Fragment>
        );
    }

    render() {
        const StepForm = this.stepFormWrapper;
        const formData = this.props.formData;
        const NavigationButtons = this.navigationButtons;

        const showBefore86 = (moment().year() - parseInt(formData.age) - 1) <= 1986;
        const showAfter86 = (moment().year() - parseInt(formData.age) - 1) >= 1986;

        const showBefore79 = (moment().year() - parseInt(formData.age) - 1) <= 1979;
        const showAfter79 = (moment().year() - parseInt(formData.age) - 1) >= 1979;

        const showFeedbackEmployedBelow30 = formData.occupation == 'employed' && formData.age < 30;
        const showFeedbackEmployedAbove30AndNoPlan = formData.occupation == 'employed' && formData.age >= 30 && formData.occupationalPlan == 'none';
        const showFeedbackEmployedAndNoPlan = formData.occupationalPlan == 'no-plan' && formData.occupation == 'employed';

        const showFeedback = (showFeedbackEmployedBelow30 || showFeedbackEmployedAbove30AndNoPlan || showFeedbackEmployedAndNoPlan);
        return (
            <StepForm heading="Vad har du för sysselsättning?">
                <RadioButton
                    layout="inline"
                    theme="big"
                    id="occupation__employed"
                    name="occupation"
                    value="employed"
                    displayname="Anställd"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={formData.occupation === 'employed'}
                />

                <RadioButton
                    layout="inline"
                    theme="big"
                    id="occupation__student"
                    name="occupation"
                    value="student"
                    displayname="Student"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={formData.occupation === 'student'}
                />

                {formData.occupation == 'employed' &&
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h5>Välj tjänstepensionsavtal</h5>

                        <Select
                            id="occupationalPlan"
                            name="occupationalPlan"
                            validations={[required]}
                            data-validation-error-message="Välj en"
                            value={formData.occupationalPlan}
                        >
                            <option value={null}>Välj</option>
                            <option value={'none'}>Inget tjänstepensionsavtal</option>
                            <option value={'no-plan'}>Mitt avtal finns inte med</option>
                            {showBefore79 &&
                                <option value={'itp-2'}>Privat anställd, född innan 1979 (ITP-2)</option>
                            }
                            {showBefore86 &&
                                <option value={'kapkl'}>Kommunalt anställd, född innan 1986 (KAP-KL)</option>
                            }
                            {showAfter86 &&
                                <option value={'akapkl'}>Kommunalt anställd, född efter 1986 (AKAP-KL)</option>
                            }
                            {showAfter79 &&
                                <option value={'itp-1'}>Privat anställd, född efter 1979 (ITP-1)</option>
                            }
                        </Select>
                    </motion.div>
                }


                <NavigationButtons />

                <Feedback condition={() => showFeedback}>
                    <div>
                        <img src="https://www.lararforsakringar.se/globalassets/forsakringar/bilderillustrationer/illustrationer/parasollbank.svg" style={{margin: '0 auto', display: 'block'}}/>
                        {showFeedbackEmployedBelow30 &&
                            <FeedbackSection>
                                <h3>Bra att ta tag i pensionen tidigt</h3>
                                <p>
                                    Känn ingen oro - du har lång tid på dig - men det är dags att ta börja tag i pensionssparandet.
                                </p>
                                <p>
                                    Försök hitta en arbetsgivare med kollektivavtal så att du får en riktig tjänstepension.
                                    Saknas kollektivavtal så är det inte säkert att du får någon tjänstepension.
                                </p>
                                <p>
                                    Se över valmöjligheterna för din tjänstepension. Du kan själv välja vilka fonder du vill ha,
                                    men gör du inte det så hamnar du automatiskt i förvalda lösningar. Det kan dock vara att se över
                                    det, så att det passar just dig och din situation.
                                </p>
                            </FeedbackSection>
                        }
                        {showFeedbackEmployedAbove30AndNoPlan &&
                            <FeedbackSection>
                                <h3>Inget tjänstepensionsavtal</h3>
                                <p>
                                    För att försäkra dig om att du får en riktig tjänstepension är det enklaste att välja en arbetsgivare med kollektivavtal.
                                </p>
                                <p>
                                    Har du inte det är det ännu viktigare att spara själv eller att förhandla till sig tjänstepension som en löneförmån.
                                </p>
                            </FeedbackSection>
                        }
                        {showFeedbackEmployedAndNoPlan &&
                            <FeedbackSection>
                                <h3>Mitt avtal finns inte med</h3>
                                <p>
                                    Då vi inte känner till ditt avtal så kommer vi inte att räkna in tjänstepension i prognosen.
                                    Om du ändå vill göra en prognos och vet att ditt avtal innehåller tjänstepension så välj något av de övriga avtalen.
                                </p>
                                <p>
                                    Du kan även <a href="https://www.lararforsakringar.se/pension--sparande/boka-radgivning/" target="_blank"> boka in en pensionsrådgivning</a> för råd.
                                </p>
                            </FeedbackSection>
                        }
                    </div>
                </Feedback>

                <NavigationButtons mobileOnly={true} />
            </StepForm>
        );
    }
}

export default connectForm(Step2Form);
